<template>
    <component
        :is="props.href ? 'a' : 'span'"
        :href="props.href"
        class="group flex h-full items-center gap-2 rounded-md outline-[var(--vx-focus-ring-color,var(--color-blue-500))] focus-visible:outline-2 focus-visible:outline-offset-4"
    >
        <vx-logo class="transition-colors ease-out group-hover:text-sky-600"></vx-logo>
        <span v-if="$slots.default" class="hidden text-base text-slate-800 sm:block"><slot></slot></span>
    </component>
</template>

<script setup>
import { VxLogo } from '@voxie/frontend-components';

const props = defineProps({
    href: {
        type: String,
        required: false,
    },
});
</script>
